import type { AhPayload } from '../ahReport';

type Campaign = AhPayload['campaign'];

export function PeriodStrip({ campaign }: { campaign: Campaign }) {
  const pct = (campaign.currentDay / campaign.totalDays) * 100;
  return (
    <div className="period-strip">
      <div className="period-strip-track">
        <div className="period-strip-half p1">
          <span className="period-strip-label">Periode 1 — wk 1+2</span>
          <span className="period-strip-dates">8 – 21 jun</span>
        </div>
        <div className="period-strip-divider" />
        <div className="period-strip-half p2">
          <span className="period-strip-label">Periode 2 — wk 3+4</span>
          <span className="period-strip-dates">22 jun – 5 jul</span>
        </div>
        <div className="period-strip-marker" style={{ left: `${pct}%` }}>
          <span>Vandaag · dag {campaign.currentDay}</span>
        </div>
      </div>
    </div>
  );
}
